import script from "./ForgotPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=3224ab34&lang=css"

const __exports__ = script;

export default __exports__